import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import {
  Folder,
  Building2,
  Database,
  Globe,
  BookOpen,
  Cpu,
  LayoutDashboard,
  MessageSquare,
  Settings,
  Users,
  Zap,
  Brain,
  Shield,
  Heart,
  Star,
  Rocket,
  Code,
  Music,
  Camera,
  Briefcase,
  ShoppingCart,
  Plane,
  Coffee,
  Palette,
  Headphones,
  Gamepad2,
  Lightbulb,
  GraduationCap,
  Stethoscope,
  Scale,
  Landmark,
  Wrench,
  Leaf,
  type LucideIcon,
} from "lucide-react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const ICON_MAP: Record<string, LucideIcon> = {
  folder: Folder,
  building: Building2,
  building2: Building2,
  database: Database,
  globe: Globe,
  book: BookOpen,
  cpu: Cpu,
  dashboard: LayoutDashboard,
  message: MessageSquare,
  settings: Settings,
  users: Users,
  zap: Zap,
  brain: Brain,
  shield: Shield,
  heart: Heart,
  star: Star,
  rocket: Rocket,
  code: Code,
  music: Music,
  camera: Camera,
  briefcase: Briefcase,
  cart: ShoppingCart,
  plane: Plane,
  coffee: Coffee,
  palette: Palette,
  headphones: Headphones,
  gamepad: Gamepad2,
  lightbulb: Lightbulb,
  graduation: GraduationCap,
  stethoscope: Stethoscope,
  scale: Scale,
  landmark: Landmark,
  wrench: Wrench,
  leaf: Leaf,
};

export type ProjectColorClasses = {
  text: string;
  softBg: string;
  solidBg: string;
};

export const COLOR_MAP: Record<string, ProjectColorClasses> = {
  blue: {
    text: "text-blue-600",
    softBg: "bg-blue-100",
    solidBg: "bg-primary",
  },
  green: {
    text: "text-green-600",
    softBg: "bg-green-100",
    solidBg: "bg-green-500",
  },
  red: {
    text: "text-red-600",
    softBg: "bg-red-100",
    solidBg: "bg-red-500",
  },
  yellow: {
    text: "text-yellow-600",
    softBg: "bg-yellow-100",
    solidBg: "bg-yellow-500",
  },
  purple: {
    text: "text-purple-600",
    softBg: "bg-purple-100",
    solidBg: "bg-purple-500",
  },
  orange: {
    text: "text-orange-600",
    softBg: "bg-orange-100",
    solidBg: "bg-orange-500",
  },
  pink: {
    text: "text-pink-600",
    softBg: "bg-pink-100",
    solidBg: "bg-pink-500",
  },
  indigo: {
    text: "text-indigo-600",
    softBg: "bg-indigo-100",
    solidBg: "bg-indigo-500",
  },
  teal: {
    text: "text-teal-600",
    softBg: "bg-teal-100",
    solidBg: "bg-teal-500",
  },
  gray: {
    text: "text-gray-600",
    softBg: "bg-gray-100",
    solidBg: "bg-gray-500",
  },
};

export function getProjectIcon(icon?: string): LucideIcon {
  return ICON_MAP[icon ?? ""] ?? Folder;
}

export function getProjectColor(color?: string): string {
  return (COLOR_MAP[color ?? ""] ?? COLOR_MAP.blue).text;
}

export function getProjectColorClasses(color?: string): ProjectColorClasses {
  return COLOR_MAP[color ?? ""] ?? COLOR_MAP.blue;
}
